export const MOBILE_FOOTER_HEIGHT = '208px';
